module.exports = __webpack_public_path__ + "img/undraw_personal_website_weap.f5fcd1da.svg";